import object from '@mailobj-browser/front/js/utils/object.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import { modifiers, helpers } from '#components/generics/js/styles.js'
import * as selector from './tools.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { list, close } from '#utilities/js/lightboxes/menus/menu.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    if (button.classList.contains(helpers.dateSelector.elements.disabled)) {
      return
    }

    const menu = list(button)
    const { value: day } = button
    const container = closest(`.${helpers.dateSelector.elements.container}`, button)
    const days = closest(`.${helpers.dateSelector.elements.days}`, button)

    selector.setTargetValue(container, day)

    for (const btn of all('button', days)) {
      btn.classList.remove(`${modifiers.button.is_primary}`)
      btn.classList.remove(`${modifiers.button.is_secondary}`)
      btn.classList.add(`${modifiers.button.is_outline}`)

      if (btn.classList.contains(helpers.dateSelector.modifiers.day.today)) {
        btn.classList.add(`${modifiers.button.is_secondary}`)
        btn.classList.remove(`${modifiers.button.is_outline}`)
      }
    }

    button.classList.add(`${modifiers.button.is_primary}`)
    button.classList.remove(`${modifiers.button.is_secondary}`)
    button.classList.remove(`${modifiers.button.is_outline}`)

    if (menu) {
      close()
    }
  }
})

export default button => {
  onClick.listen(button)
}
